import { Component, OnInit } from '@angular/core'
import { DataCheckerService, Destroyable, untilDestroy } from '@tokeet-frontend/tv3-platform'
import {
  availableMessageChannels,
  MessagingChannelGuard,
  MessagingChannelKeys,
  MessagingChannelsConfig,
  MessagingChannelType,
  selectMessagingChannels,
} from '@tokeet-frontend/message'
import { select, Store } from '@ngrx/store'
import { MatDialogRef } from '@angular/material/dialog'
import { selectActiveProductPlanView } from '@tv3/store/plan/plan.selectors'
import { ProductsForPlan } from '@tv3/store/plan/plan.model'
import { AppOverviewDialogService } from '@tokeet-frontend/billing'
import { HttpClient } from '@angular/common/http'
import { MessagingChannelHelperService } from '@tv3/containers/messages/messaging-channel-helper.service'
import { ConnectInstagramDialogService } from '@tv3/containers/messages/connect-instagram-dialog/connect-instagram-dialog.service'
import { environment } from '@tv3/environments/environment'
import { ConnectFacebookDialogService } from '@tv3/containers/messages/connect-facebook-dialog/connect-facebook-dialog.service'
import { ConnectGmailDialogService } from '@tv3/containers/messages/connect-gmail-dialog/connect-gmail-dialog.service'

export enum MessagingSettingsTabs {
  Channels,
  Charges,
}

@Component({
  selector: 'app-messaging-settings',
  templateUrl: './messaging-settings.component.html',
  styleUrls: ['./messaging-settings.component.scss'],
})
export class MessagingSettingsComponent extends Destroyable implements OnInit {
  tabs = MessagingSettingsTabs
  activeTab = MessagingSettingsTabs.Channels

  channelConfig: MessagingChannelsConfig

  types = MessagingChannelType
  isProduction = environment.environment === 'production'

  items = availableMessageChannels.filter((item) => (this.isProduction ? item.isProdReady : true))

  isMessagingSubscribed = false

  facebookPages: { name: string }[]
  constructor(
    private store: Store<any>,
    private appOverviewDialog: AppOverviewDialogService,
    public dialogRef: MatDialogRef<MessagingSettingsComponent>,
    private dataChecker: DataCheckerService,
    private helper: MessagingChannelHelperService,
    private connectInstagramDialog: ConnectInstagramDialogService,
    private connectFacebookDialog: ConnectFacebookDialogService,
    private connectGmailDialog: ConnectGmailDialogService,
    private http: HttpClient
  ) {
    super()
    this.dataChecker.check([MessagingChannelGuard])
  }

  async ngOnInit() {
    try {
      const response = await this.http.get<{ name: string }[]>('@api/v1/message/facebook/pages').toPromise()
      this.facebookPages = response?.['response']
    } catch (e) {}

    this.store.pipe(select(selectMessagingChannels), untilDestroy(this)).subscribe((d) => {
      this.channelConfig = d
    })

    this.store
      .pipe(select(selectActiveProductPlanView(ProductsForPlan.Messaging)), untilDestroy(this))
      .subscribe((sub) => {
        this.isMessagingSubscribed = sub?.isValid
      })
  }

  onConnect(channel: MessagingChannelKeys) {
    switch (channel) {
      case 'instagram':
        this.connectInstagramDialog.open()
        break
      case 'facebook':
        this.connectFacebookDialog.open()
        break
      case 'gmail':
        this.connectGmailDialog.open()
        break
      default:
        this.helper.connect(channel).subscribe()
    }
  }

  onDisconnect(channel: MessagingChannelKeys) {
    this.helper.disconnect(channel)
  }

  onSubscribe() {
    this.appOverviewDialog.open(ProductsForPlan.Messaging)
  }

  close() {
    this.dialogRef.close()
  }
}
